export default __webpack_public_path__ + "static/media/supportt.7d9ad383.webp";